import { useEffect, useRef } from 'react';
import { insert, setInputFilter } from '../../../helpers';
import { StyledInput } from './TimeInput.styles';

const TimeInput = ({ value, onChange, ...otherProps }) => {
  const timeInputRef = useRef();

  // Allow digits and ':' only
  useEffect(() => {
    setInputFilter(document.getElementById('myTextBox'), function (value) {
      return /^\d*:?\d*$/.test(value);
    });
  });

  return (
    <StyledInput
      autoComplete="off"
      ref={timeInputRef}
      id="myTextBox"
      type="text"
      onChange={onChange}
      value={value}
      {...otherProps}
    />
  );
};

export default TimeInput;
